import React from 'react';
import { set } from 'date-fns';

//assets
import { PencilIcon } from 'assets/icons';
import { IconWrapper } from 'common/components';
import { IconContainer } from 'common/components/styled/IconWrapper.styled';
import { DeleteIcon } from 'components/common/DeleteIcon/DeleteIcon';

interface IBedroomsEdit {
  setSideBar: (s: boolean) => void;
  setActiveBedroom: any;
  setDeleteModal: (d: boolean) => void;
  rowData: {
    data: object;
  };
}

export const BedroomsEdit = ({
  setSideBar = () => null,
  setActiveBedroom,
  setDeleteModal,
  rowData,
}: IBedroomsEdit) => {
  const handleEdit = () => {
    console.log('rowData', rowData);
    setActiveBedroom(rowData.data);
    setSideBar(true);
  };

  const handleDelete = () => {
    setActiveBedroom(rowData.data);
    setDeleteModal(true);
  };

  return (
    <IconContainer justifyContent="space-between">
      <IconWrapper onClick={handleEdit}>
        <PencilIcon />
      </IconWrapper>
      <IconWrapper onClick={handleDelete}>
        <DeleteIcon tooltipText="Delete room" disabled={false} />
      </IconWrapper>
    </IconContainer>
  );
};
